// extracted by mini-css-extract-plugin
export default {"text":"ymasu ZdH1P","title":"qLqp8","subtitle":"nTz_c","list":"NUlLt ZdH1P","category":"t3sS2","galleryWrapper":"f4m4C ZdH1P","gallery":"T0_Uj","slide":"L6H5F"};